import ccSession from "./ccSession";
import reportsSession from "./session";

export default {
  fetchStatusMetrics() {
    return ccSession.get('/status-metrics/');
  },

  fetchCreditControlAccounts(config) {
    return ccSession.get(`/accounts/?page=${config.page}&page_size=${config.page_size}&payment_method=${config.payment_method}&last_dd_failed_reason=${config.last_dd_failed_reason}&most_recent_payment_date__gte=${config.most_recent_payment_date__gte}&most_recent_payment_date__lte=${config.most_recent_payment_date__lte}&status__in=${config.status.join(',')}&exclusion_kind__in=${config.exclusion_kind.join(',')}&status_reason__in=${config.status_reason}`);
  },

  exportToCSV(config) {
    return reportsSession.get(`/credit-control/accounts/report/?payment_method=${config.payment_method}&last_dd_failed_reason=${config.last_dd_failed_reason}&most_recent_payment_date__gte=${config.most_recent_payment_date__gte}&most_recent_payment_date__lte=${config.most_recent_payment_date__lte}&status__in=${config.status.join(',')}&exclusion_kind__in=${config.exclusion_kind.join(",")}&status_reason__in=${config.status_reason.join(',')}`);
  },

  sendToDialer(config) {
    return reportsSession.get(`/credit-control/accounts/to-dialler/?payment_method=${config.payment_method}&last_dd_failed_reason=${config.last_dd_failed_reason}&most_recent_payment_date__gte=${config.most_recent_payment_date__gte}&most_recent_payment_date__lte=${config.most_recent_payment_date__lte}&status__in=${config.status.join(',')}&exclusion_kind__in=${config.exclusion_kind.join(",")}&status_reason__in=${config.status_reason.join(',')}`);
  },
}